type Context = 'developer';

type Section = 'status' | 'keys' | 'usage' | 'credits' | 'invoices';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  status: 'developer-status',
  keys: 'developer-keys',
  usage: 'developer-usage',
  credits: 'developer-credits',
  invoices: 'developer-invoices',
};
